function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityLocationChange = function SvgActivityLocationChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "#fff",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.366-1a7.374 7.374 0 0 1 7.366 7.366c0 5.441-6.387 11.891-6.659 12.162l-.707.707-.707-.707C5.387 18.256-1 11.807-1 6.366A7.374 7.374 0 0 1 6.366-1zm0 17.358c1.6-1.777 5.366-6.342 5.366-9.993A5.366 5.366 0 1 0 1 6.366c0 3.657 3.764 8.217 5.365 9.992zm0-13.115a3.122 3.122 0 1 1-3.122 3.123 3.126 3.126 0 0 1 3.122-3.122zm0 4.244a1.122 1.122 0 1 0-1.122-1.121 1.123 1.123 0 0 0 1.122 1.122z",
    "data-name": "Path 11774",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(1.239 2.179)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7759.647-2943.857-.708-.706a25.721 25.721 0 0 1-2.467-2.958l-.1-.146c.426-.615.824-1.232 1.181-1.834a23.572 23.572 0 0 0 2.1 2.766c.872-.989 3.722-4.419 3.722-7.03a3.738 3.738 0 0 0-3.435-3.711 8.43 8.43 0 0 0-.431-2.01h.144a5.727 5.727 0 0 1 5.72 5.722c0 1.779-.857 3.88-2.547 6.245a25.721 25.721 0 0 1-2.467 2.958l-.706.706zm0-7.336a2.544 2.544 0 0 1-1.069-.233 17.5 17.5 0 0 0 .76-1.858.572.572 0 0 0 .309.091.575.575 0 0 0 .574-.574.575.575 0 0 0-.57-.573 10.2 10.2 0 0 0 .306-1.982 2.574 2.574 0 0 1 2.262 2.555 2.576 2.576 0 0 1-2.572 2.574z",
    "data-name": "Subtraction 11",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(7775.687 2965.271)"
  })));
};
export default SvgActivityLocationChange;